<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>二级商户签约</span>
      <el-steps :active="3" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 填写签约信息" icon="el-icon-edit-outline"></el-step>
        <el-step title="2 签约信息确认" icon="el-icon-s-platform"></el-step>
        <el-step title="3 证照资料上传" icon="el-icon-s-check"></el-step>
        <el-step title="4 签约成功" icon="el-icon-success"></el-step>
      </el-steps>
      <el-button class="but2">
        <img class="icon_input" src="@/assets/images/icon_input.png" alt=""/>
        <span class="sp2">证照资料上传</span>
      </el-button>
      <el-form class="form" :model="uploadInfo" :rules="rules" ref="uploadInfo" label-width="160px">
        <el-form-item class="sp3" label="二级商户编号" prop="subMerNo" style="margin-top: 20px">
          <el-input v-model="uploadInfo.subMerNo" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="上传资料类型" prop="flag" style="margin-top: 20px">
          <el-select v-model="uploadInfo.flag" placeholder="请选择" style="width: 300px">
            <el-option v-for="item in uploadTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="sp3" label="上传zip文件" prop="formZip">
          <input type="file" id="zipFile" accept=".zip" @change="uploadFile"></input>
          <input type="hidden" :value="uploadInfo.subMerCertFile"></input>
        </el-form-item>
        <el-form-item style="text-align: center;margin-left: -300px">
          <el-button type="primary" @click="submitForm('uploadInfo')">证照资料上传</el-button>
        </el-form-item>
      </el-form>
      <div class="note">
        <span>1、企业户请依次上传企业营业执照照片、法人/经营者身份证正反面照片及辅助证明材料；</span><br>
        <span>2、辅助证明材料为《母公司与分公司证明》并加盖集团公章，模板可从总部信息中心获取；</span><br>
        <span>3、上传文件的格式必须为ZIP格式，将需要上传的图片或材料压缩成ZIP文件，单次最大可传递1.5MB。</span>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {infoUpload} from "../../../api/system/bank_abc";
import {mapGetters} from "vuex";

export default {
  data(){
    return{
      uploadInfo: {
        subMerNo:'',
        flag:'1',//上传标识： 1：个体工商户/企业营业执照照片 3：辅助证明材料 4：法定代表人/经营者身份证人像面照片 5：法定代表人/经营者身份证国徽面照片
        subMerCertFile:''
      },
      uploadTypeOptions:[{
        value:'1',
        label:'个体工商户/企业营业执照照片'
      },{
        value:'3',
        label:'辅助证明材料'
      },{
        value:'4',
        label:'法定代表人/经营者身份证人像面照片'
      },{
        value:'5',
        label:'法定代表人/经营者身份证国徽面照片'
      }],
      rules:{
        flag:[{
          required: true , message:'请选上传资料类型' , trigger: 'blur'
        }],
        subMerNo:[
          { required: true , message:'请输入二级商户编号' , trigger: 'blur'}
        ],
        subMerCertFile:[
          { required: true , message:'请上传zip文件' , trigger: 'blur'}
        ],
      },
      timeLineHeight: ""
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted(){
    this.uploadInfo.subMerNo = this.$route.query.subMerId
    this.timeLineHeight = document.documentElement.clientHeight -50;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight;
    };
    if(this.index === null){
      this.$message({
        type:'error',
        message:'请在财务组织选择页面选取个人所属公司！'
      });
    }
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    submitForm(formName){
      if(this.uploadInfo.subMerCertFile === ''){
        this.$modal.msg("请选择需要上传的文件");
        return
      }
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if(valid){
          infoUpload(JSON.stringify(_this.uploadInfo)).then(
            res => {
              // console.log(res)
              let json = JSON.parse(res.data)
              // console.log(json)
              if(json.ReturnCode === "0000"){
                this.$message({
                  type:'success',
                  message:'文件上传成功'
                });
                if(this.uploadInfo.flag === '1'){
                  this.uploadInfo.flag = '4'
                  this.uploadInfo.subMerCertFile = ''
                }else if(this.uploadInfo.flag === '4'){
                  this.uploadInfo.flag = '5'
                  this.uploadInfo.subMerCertFile = ''
                }else if(this.uploadInfo.flag === '5'){
                  this.uploadInfo.flag = '3'
                  this.uploadInfo.subMerCertFile = ''
                }else if(this.uploadInfo.flag === '3'){
                  this.toSuccess()
                }
              }else{
                this.$message({
                  type:'error',
                  message: json.ErrorMessage
                })
              }
            }
          )
        }else{
          return false;
        }
      })
    },
    uploadFile(){
      //debugger;
      let _this = this;
      let reads = new FileReader();
      let file = document.getElementById('zipFile').files[0];
      reads.readAsDataURL(file);
      //console.log(reads);
      reads.onload = function(e){
        //console.log(e);
        _this.uploadInfo.subMerCertFile = e.target.result.substring(e.target.result.indexOf(',') + 1);
        console.log(_this.uploadInfo.subMerCertFile)
      }
    },
    toSuccess(){
      this.$router.push({path: '/signSuccess'})
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_pay{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-right: 8px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .form{
    border:1px solid #EBEEF5;
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .icon_input{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: -1px;
    margin-left: -1px;
  }
  .sp2{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
  .sp3{
    margin-left: 70px;
  }
  .note{
    margin-top: 30px;
    padding: 20px 40px;
    background: #f5f7fa;
    color: #ff5000;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    font-weight: bold;
    max-width: 100%;
  }
</style>
